module.exports = __webpack_public_path__ + "img/EgyptTechPriestHeal1_ua.7987230d.webp";